// @flow
import { Corporate, Reseller } from '@gandi/icons';
import { Icon } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

type Props = { kind: 'corporate' | 'reseller' };

export function DecorationIcon({ kind }: Props): React.MixedElement {
  const { __ } = useTranslator();

  const title: Record<Props['kind'], string> = {
    corporate: __('Corporate'),
    reseller: __('Reseller'),
  };

  const icon: Record<Props['kind'], React.ElementType> = {
    corporate: Corporate,
    reseller: Reseller,
  };

  return <Icon attributes={{ title: title[kind] }} svg={icon[kind]} size={6} />;
}
